var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TabsComponent',{attrs:{"tabs":_vm.tabs},scopedSlots:_vm._u([{key:"default",fn:function({ tabId }){return [_c('ComponentResolver',{attrs:{"componentId":_vm.getComponentId(tabId),"componentProps":{
        applicationId: _vm.applicationId,
        document: _vm.getDocument(tabId),
        schema: _vm.getSchema(tabId)
      }}})]}},{key:"label",fn:function({ tabId }){return [_c('div',[_vm._v(_vm._s(_vm.getDocumentName(tabId)))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }